var _path;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgPallet = function SvgPallet(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "currentColor",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40057 0L1.31818 0.556273L0 9.78355V14.5H3.95455V13.1818H11.8636V14.5H15.8182V9.78355L14.5 0.556273L14.4176 0H1.40057ZM2.55398 1.31818H3.91368L3.33632 9.22727H1.421L2.55398 1.31818ZM5.23186 1.31818H7.25V9.22727H4.6545L5.23186 1.31818ZM8.56818 1.31818H10.587L11.1637 9.22727H8.56818V1.31818ZM11.9052 1.31818H13.2642L14.3972 9.22727H12.4812L11.9052 1.31818ZM1.31818 10.5455H14.5V13.1818H13.1818V11.8636H2.63636V13.1818H1.31818V10.5455Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pallet.ee224f60.svg";
export { ForwardRef as ReactComponent };